// src/components/PublicHeader.js
import React, { useMemo } from 'react';
import './MuultiStyle.css';

export default function PublicHeader({
                                         profilePicUrl,
                                         pageTitle,
                                         pageDescription,
                                         alignment = 'left',
                                         headerPadding,
                                         style: headerStyle,
                                         children,
                                     }) {
    // Build padding style from config (always runs, safe for hooks)
    const paddingStyle = useMemo(() => {
        const hp = headerPadding || {
            mode: 'per-side',
            unit: 'px',
            top: 16,
            right: 16,
            bottom: 16,
            left: 16,
            all: 16,
        };
        const u = hp.unit || 'px';
        if (hp.mode === 'all-sides') {
            const v = hp.all ?? 16;
            return { padding: `${v}${u}` };
        }
        const t = hp.top ?? 16;
        const r = hp.right ?? 16;
        const b = hp.bottom ?? 16;
        const l = hp.left ?? 16;
        return { padding: `${t}${u} ${r}${u} ${b}${u} ${l}${u}` };
    }, [headerPadding]);

    // ✅ after hooks: safe to bail early
    if (!pageTitle && !profilePicUrl && !pageDescription && !children) return null;

      return (
            <div
      className="public-header"
      style={{
        textAlign: alignment,
            ...paddingStyle,          // padding from headerPadding
            ...(headerStyle || {}),   // ← bg/border/etc. from parent
          }}
    >
            {pageTitle && <h1>{pageTitle}</h1>}

            {alignment === 'left' && (
                <div className="public-header-content">
                    {profilePicUrl && (
                        <div>
                            <img
                                src={profilePicUrl}
                                className="public-profile-pic"
                                alt={pageTitle || 'Profile pic'}
                            />
                        </div>
                    )}
                    <div>{pageDescription && <p>{pageDescription}</p>}</div>
                </div>
            )}

                {/* CENTER */}
                {alignment === 'center' && (
                    <div className="public-header-center">
                        {profilePicUrl && (
                            <img
                                src={profilePicUrl}
                                className="public-profile-pic"
                                alt={pageTitle || 'Profile pic'}
                            />
                        )}
                        {pageDescription && <p>{pageDescription}</p>}
                    </div>
                )}

            {alignment === 'right' && (
                <div className="public-header-content-right">
                    <div>
                        {profilePicUrl && (
                            <img
                                src={profilePicUrl}
                                className="public-profile-pic"
                                alt={pageTitle || 'Profile pic'}
                            />
                        )}
                    </div>
                    <div>{pageDescription && <p>{pageDescription}</p>}</div>
                </div>
            )}
            {children}
        </div>
    );
}
